import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.scss']
})
export class StudentsComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = BOOK_STORE_TABS.STUDENTS;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: BookstoreStore,
    public ps: PrintService,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      this.store.fetchData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key)
    })
  }

  create() {
    this.router.navigate([`/enrollment/students/admission/draft`])
  }
  
  edit(item:any) {
    this.router.navigate([`/enrollment/students/admission/${item.key}`])
  }
}
